import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  SwipeableDrawer,
} from "@mui/material";
import { apiURL } from "../../../../config/default";

const PositionEditor = ({
  initialPosition,
  edit,
  setEdit,
  editingIndices,
  menuData,
  setMenuData,
}) => {
  if (!initialPosition) {
    initialPosition = 0;
  }
  const [position, setPosition] = useState(null);

  const handleUpdate = async () => {
    let updatedMenuData = menuData;
    let submenu = [];
    let variations = [];

    if (editingIndices.length === 1) {
      updatedMenuData = updatedMenuData.sort((a, b) => a.position - b.position);
    } else if (editingIndices.length === 2) {
      submenu = updatedMenuData[editingIndices[0]].submenu;
      const sortedSubmenu = [...submenu].sort(
        (a, b) => a.position - b.position
      );
      updatedMenuData[editingIndices[0]].submenu = sortedSubmenu;
    } else {
      variations =
        updatedMenuData[editingIndices[0]].submenu[editingIndices[1]]
          .variations;
      const sortedVariations = [...variations].sort(
        (a, b) => a.position - b.position
      );
      updatedMenuData[editingIndices[0]].submenu[editingIndices[1]].variations =
        sortedVariations;
    }

    if (editingIndices.length === 1) {
      updatedMenuData[editingIndices[0]].position = position;
    } else if (editingIndices.length === 2) {
      updatedMenuData[editingIndices[0]].submenu[editingIndices[1]].position =
        position;
    } else {
      updatedMenuData[editingIndices[0]].submenu[editingIndices[1]].variations[
        editingIndices[2]
      ].position = position;
    }

    // Save to backend
    try {
      await fetch(`${apiURL}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedMenuData),
      });
    } catch (error) {
      console.error("Error saving menu data:", error);
    }
    console.log({ updatedMenuData });

    setMenuData([...updatedMenuData]);
    setPosition(null);
    setEdit({
      open: false,
      edit: "",
      title: "",
    });
  };

  return (
    <SwipeableDrawer
      anchor={"right"}
      open={edit.open}
      onClose={() =>
        setEdit({
          open: false,
          edit: "",
          title: "",
        })
      }
      onOpen={() => {}}
      PaperProps={{
        sx: {
          height: "auto", // Set height to auto
          maxHeight: "80vh", // Optional: max height to prevent overflow
          width: "300px",
          paddingBottom: "100px",
          overflow: "hidden",
        },
      }}
    >
      <Box
        sx={{
          bgcolor: "white",
          borderRadius: "4px",
          p: 2,
          width: "300px",
        }}
      >
        <Typography
          sx={{
            borderBottom: "1px solid #e0e0e0",
            pb: 1,
            mb: 2,
            fontSize: "14px",
          }}
        >
          Position
        </Typography>

        <Box sx={{ mb: 2 }}>
          <Typography sx={{ mb: 0.5, fontSize: "12px" }}>Position:</Typography>
          <TextField
            fullWidth
            size="small"
            type="number"
            value={position || initialPosition}
            onChange={(e) => setPosition(Number(e.target.value))}
            sx={{ mb: 1 }}
          />
        </Box>

        <Button
          fullWidth
          variant="contained"
          disabled={!position}
          onClick={handleUpdate}
          sx={{
            bgcolor: "#2e7d32",
            color: "white",
            "&:hover": {
              bgcolor: "#1b5e20",
            },
            marginTop: "30px",
          }}
        >
          Update
        </Button>
      </Box>
    </SwipeableDrawer>
  );
};

export default PositionEditor;
